/**
 * 時刻帯別あいさつ (ASK-WEB-002)。
 *
 * HomePage の `t('home.greeting.<band>', { name })` で使う band キーを返す。
 * 境界: 一般的な日本語あいさつの慣習に合わせる。
 *   - 05:00–10:59 → 'morning'   (おはようございます / Good morning)
 *   - 11:00–17:59 → 'afternoon' (こんにちは        / Good afternoon)
 *   - 18:00–04:59 → 'evening'   (こんばんは        / Good evening)
 *
 * ローカル時刻 (`Date.getHours`) で判定する。UTC ではない (ユーザー体感優先)。
 */
export type GreetingBand = 'morning' | 'afternoon' | 'evening'

export const getGreetingBand = (date: Date): GreetingBand => {
  const hour = date.getHours()
  if (hour >= 5 && hour < 11) return 'morning'
  if (hour >= 11 && hour < 18) return 'afternoon'

  return 'evening'
}
